export default __webpack_public_path__ + "static/legendia-d9d52520bbfac97d55d718b75a5aed2f.svg";